/* eslint no-console: ["error", { allow: ["warn"] }] */
import { exponentialBackoff } from "@iventis/utilities";
import { getWhat3WordsApiKey } from "./what3words-api-keys";
import { WHAT3WORDS_MAX_RETRY_ATTEMPTS, WHAT3WORDS_REFETCH_RETRY_MS } from "./what3words-constants";

/**
 * Gets a what3words value from a set of coordinates
 *
 * Will attempt to refetch the data if the status is 429 (3 times max)
 *
 * If not 200 status (success) then will return an empty string
 * */
export async function getWhat3WordsValue(lat: number, lng: number, fetchRetryMs = WHAT3WORDS_REFETCH_RETRY_MS, maxAttempts = WHAT3WORDS_MAX_RETRY_ATTEMPTS): Promise<string> {
    const request = () => fetch(`https://api.what3words.com/v3/convert-to-3wa?coordinates=${lng}%2C${lat}&key=${getWhat3WordsApiKey()}`);
    try {
        const response = await exponentialBackoff<Response>(request, fetchRetryMs, maxAttempts);
        if (response.status !== 200) {
            console.warn("Error with what3words API");
            return "";
        }
        const responseJson = await response.json();
        return responseJson.words;
    } catch (err) {
        console.warn(`Rate limit hit with what3words API, attempted to refetch ${WHAT3WORDS_MAX_RETRY_ATTEMPTS} times`);
        return "";
    }
}
